<template>
  <div>
    <v-card>
      <v-form ref="form" lazy-validation>
        <v-card-title>Solicitar PickUp a FedEx</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-combobox
                v-model="cuenta"
                :items="cuentas"
                item-text="nombre"
                item-value="cuenta"
                label="Cuenta"
                append-icon="check_circle"
                return-object
                :disabled="disableAll"
                :rules="[reglas.requeridoCbx]"
                required
              ></v-combobox>
              <div v-if="cuenta">{{ cuenta.cuenta }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogFecha"
                v-model="modalFecha"
                :return-value.sync="fecha"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecha"
                    label="Fecha de Recolecta"
                    append-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha"
                  scrollable
                  no-title
                  @input="
                    modalFecha = false;
                    $refs.dialogFecha.save(fecha);
                  "
                  :disabled="disableAll"
                >
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogHora"
                v-model="modalHora"
                :return-value.sync="hora"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="hora"
                    label="Hora de Recolecta"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="hora">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogHora.save(hora)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-dialog
                ref="dialogHoraC"
                v-model="modalHoraC"
                :return-value.sync="horaC"
                persistent
                width="290px"
                :disabled="disableAll"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="horaC"
                    label="Cerrado a Las"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[reglas.requeridoTxt]"
                    required
                    :disabled="disableAll"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="horaC">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogHoraC.save(horaC)"
                    >OK</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="indicaciones"
                label="Indicaciones"
                append-icon="edit"
                :disabled="disableAll"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn :disabled="disableAll" color="primary" outlined @click="enviar()">
            Enviar Pickup a FedEx
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from '../components/Waiting.vue';
import apicon from '../plugins/apicon';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting
  },
  created: function () {},
  data() {
    return {
      cuentas: [],
      cuenta: null,
      modalFecha: false,
      fecha: null,
      modalHora: false,
      hora: null,
      modalHoraC: false,
      horaC: null,
      indicaciones: null,
      overlay: false,
      disableAll: false,
    };
  },
  methods: {
    fillCuentas: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "cuentas/FedEx").then((result) => {
        this.cuentas = result;
      });
    },
    //Enviar guia a FedEx
    enviar: async function () {
      if (this.$refs.form.validate()) {
          this.overlay = true;
          //var fechaMod = this.replace(this.fecha,'-','');
          //var horaMod = this.replace(this.hora,':','');
          //var horaCMod = this.replace(this.horaC,':','');
        var datos = {
          cuentaId: this.cuenta.id,
          id: this.id,
          cuenta: this.cuenta.cuenta,
          puhora: this.hora,
          pufecha: this.fecha,
          puhoracer: this.horaC,
          puindicaciones: this.indicaciones,
        };
        apicon.saveDataApi(apicon.getApiBaseUrl() + "pickupfedex", datos).then((result) => {
            if(result.status){
              if (result.data.output && result.data.output.pickupConfirmationCode){
                this.disableAll = true;
                this.$swal('Se ha generado la recolecta en FEDEX su numero de recolecta es : ' + result.data.output.pickupConfirmationCode);
              }else{
                this.$swal("No se ha podido generar la recolecta, intente nuevamente");
              }
            }else{
              let errorsStr = result.message + " : ";
              if(result.errors){
                result.errors.forEach(error => {
                  errorsStr = errorsStr + " " + "(" + error.code + ") " + error.message + ", "
                });
              }
              this.$swal(errorsStr);
            }
        }).finally(() => {
          this.overlay = false;
        });
      }
    },
     replace: function (st, rep, repWith) {
      const result = st.split(rep).join(repWith)
      return result;
    }
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillCuentas();
  },
};
</script>
